<div *ngIf="items;else loadingBlock" class="list-container" style="margin-top: 25px;">
    <ng-container *ngFor="let sideMenuIndex of sortedMenuConfigsIds">
      <side-menu-item
        [selectedIndex]="selectedIndex"
        [sideMenuIndex]="sideMenuIndex"
        [sideMenuConfigs]="menuConfigs.get(sideMenuIndex)"
        [selectedSideMenuIndex]="selectedSideMenuIndex"
        (onSelection)="selectedSideMenuIndex = $event"
        (onNavigate)="loadContent($event)"
      />
    </ng-container>
</div>
<ng-template #loadingBlock>
  <div class="mt-25">
    <mat-spinner diameter="50"></mat-spinner>
    <span class="text-primary">Caricamento in corso...</span>
  </div>
</ng-template>
